import React, { useEffect } from "react";
import "./style.scss";
import CloseBtn from "../CloseBtn";
import UserCard from "../UserCard";
import TitleExpand from "../Expandtitle";
import { formatDate } from "../../Utils/helper";
import Storelist from "../../Store/Actions";
import Api from "../../Utils/Api";
import { toast } from "react-toastify";

const CreateRequest = () => {

  const {
    CreateRequestDetailsStore,
    setServicePackage_,
    setCreateRequestData_,
    RequestUserStore,
    setLoading,
    clearCreateRequestData_,
    setCreatemodal_,
    setSlotDates_,
    setAddresslist_,
    setBikelist_,
  } = Storelist();

  const {
    GetCityList,
    CheckMobile,
    _Post_MobileNumber,
    GetAddressTypeList,
    GetBranchList,
    servicePackageDetail,
    GetbikeTypesList,
    GetSlotTimes,
    verifyPincode,
    GetOfferAndServiceRequiredList,
    GetServicePackage,
    verifyEmailIdForNewRequest
  } = Api();





  const isValidEmail = (email) => {

    const regex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regex.test(email);
  };



  // const checkEmail = async (email) => {

  //   console.log("API Called:", email);

  //   // Example API call
  //   // await axios.post("/check-email", { email });

  // };



  const validateEmail = async (email) => {
    const isValid = isValidEmail(email);
    if (!isValid) return


    const timer = setTimeout(() => {
      verifyEmailIdForNewRequest({
        emailId: email
      })

    }, 1000)


    return () => clearTimeout(timer);

  }



  const TextInputHandler = async (e) => {
    if (e.target.name === "mobile") {
      e.target.value = e.target.value?.replace(/[^0-9]+/g, "")?.slice(0, 10);
    }
    if (e.target.name === "name") {
      e.target.value = e.target.value
        ?.replace(/[^a-z A-Z]+/g, "")
        ?.slice(0, 80);
    }
    if (e.target.name === "addressName") {
      // e.target.value = e.target.value?.replace(/[^a-z A-Z]+/g, '')?.slice(0,80);
      setCreateRequestData_({ key: "address_id", value: "" });
    }
    if (e.target.name === "full_address") {
      setCreateRequestData_({ key: "address_id", value: "" });
    }
    if (e.target.name === "pincode") {
      if (!RequestUserStore.bikeType || !RequestUserStore.gearSystem) {
        toast.error("Please select Bike Type and Gear System first", { position: "top-center" });
        toast.clearWaitingQueue();
        return;
      }
      e.target.value = e.target.value?.replace(/[^0-9]+/g, "")?.slice(0, 6);
      if (e?.target?.value?.length === 6) {
        console.log("enterinfg")
        verifyPincode({ pincode: parseInt(e.target.value) });
      }
      setCreateRequestData_({ key: "address_id", value: "" });
    }
    if (e.target.name === "amount") {
      e.target.value = e.target.value?.replace(/[^0-9]+/g, "")?.slice(0, 10);
    }
    if (e.target.name === "email") {
      validateEmail(e.target.value);
    }
    setCreateRequestData_({ key: e.target.name, value: e.target.value });

    if (e.target.name === "mobile" && e.target?.value?.length === 10) {
      CheckMobile({
        mobileNumber: e.target?.value,
      });
    }
  };

  // const getNext90DatesFromToday = () => {
  //   const dates = [];
  //   const today = new Date();

  //   // Start from tomorrow
  //   const startDate = new Date(today);
  //   startDate.setDate(today.getDate() );

  //   for (let i = 0; i < 90; i++) {
  //     const date = new Date(startDate);
  //     date.setDate(startDate.getDate() + i);
  //     dates.push(date.toISOString().split("T")[0]); // Format: YYYY-MM-DD
  //   }

  //   setSlotDates_(dates);
  // };

  const getLocalDateStr = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const timeFormater = (date) => {
    const localTime = new Date(date);

    // Format as local time with AM/PM
    const formattedTime = localTime.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return formattedTime;
  };

  const SelectHandler = (e) => {
    console.log("select changed");
    console.log(e.target.name, e.target.value);
    if (e.target.name === "city") {
      console.log("city changed");
      if (!RequestUserStore.bikeType || !RequestUserStore.gearSystem) {
        toast.error("Please select Bike Type and Gear System first");
        return;
      }
      GetOfferAndServiceRequiredList(true, e.target.value);
      GetBranchList(true, e.target.value);
    }
    if (e.target.name === "address_type") {
      setCreateRequestData_({ key: "address_id", value: "" });
    }
    if (e.target.name === "branch") {
      console.log("branch changed");
      setCreateRequestData_({ key: "branch", value: e.target.value });
      setCreateRequestData_({ key: "serviceRequired", value: "" });
      setCreateRequestData_({ key: "servicePackage", value: "" });
      setCreateRequestData_({ key: "slotDate", value: "" });
      setCreateRequestData_({ key: "slotTime", value: "" });
      setCreateRequestData_({ key: "amount", value: "" });
      setServicePackage_([]);
    }
    if (e.target.name === "serviceRequired") {
      // getPackageList();
      console.log("SDFGHJKL:")
      setCreateRequestData_({ key: "servicePackage", value: "" });
      setServicePackage_([]);
      setCreateRequestData_({ key: "amount", value: "" });
      setCreateRequestData_({ key: "slotDate", value: "" });
      setCreateRequestData_({ key: "slotTime", value: "" });
      console.log("completed");
      console.log(RequestUserStore?.servicePackage)
    }
    if (e.target.name === "servicePackage") {
      console.log(e.target.value);
      setCreateRequestData_({ key: "slotDate", value: "" });
      setCreateRequestData_({ key: "slotTime", value: "" });
      const selectedPackage = CreateRequestDetailsStore?.servicePackage?.find(
        (item) => item?.serviceCategoryName === e.target.value
      );
      const payload = {
        bikeType: RequestUserStore.bikeType,
        gearSystem: RequestUserStore.gearSystem,
        serviceType: RequestUserStore.serviceRequired,
        servicePackage:
          selectedPackage?._id || selectedPackage?.id || e.target.value,
      };

      if (RequestUserStore.bike_id) {
        payload.bikeid = RequestUserStore.bike_id
      }
      servicePackageDetail(payload);
    }
    if (e.target.name === "slotDate") {
      const localSlotDate = getLocalDateStr(e.target.value);
      if (RequestUserStore.serviceRequired && RequestUserStore.city) {
        GetSlotTimes({
          serviceType: RequestUserStore.serviceRequired,
          cityId: RequestUserStore.city,
          branchId: RequestUserStore.branch,
          slotDate: localSlotDate,
        });
      }
      setCreateRequestData_({ key: "slotDate", value: e.target.value });
      setCreateRequestData_({ key: "slotTime", value: "" });
      return;
    }

    setCreateRequestData_({ key: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    if (
      RequestUserStore.bikeType &&
      RequestUserStore.gearSystem &&
      RequestUserStore.serviceRequired
    ) {
      const obj = {
        bikeType: RequestUserStore.bikeType,
        gearType: RequestUserStore.gearSystem,
        serviceType: RequestUserStore.serviceRequired,
      };
      if (RequestUserStore.bike_id) {
        obj.bikeid = RequestUserStore.bike_id;
      }
      GetServicePackage(obj);
    }
  }, [
    RequestUserStore.bikeType,
    RequestUserStore.gearSystem,
    RequestUserStore.servicePackage,
    RequestUserStore.serviceRequired,
  ]);

  
  const AddressItemSet = (item) => {
    setCreateRequestData_({ key: "selectedAddress", value: item?._id });
    verifyPincode({ pincode: item.pincode });
  };

  const StateHandler = (e) => {
    setLoading(true);
    GetCityList(e.target.value);
    setCreateRequestData_({ key: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    GetbikeTypesList(true);

    GetAddressTypeList();

    // If a mobile is pre-filled (e.g. from warranty detail), auto-check it
    const preMobile = RequestUserStore?.mobile;
    if (preMobile && String(preMobile).length === 10) {
      CheckMobile({ mobileNumber: String(preMobile) });
    }
  }, []);

  useEffect(() => {
    const activeDates = (CreateRequestDetailsStore?.slotsAvailable || [])
      .filter((slot) => {
        const active =
          slot?.isactive === 1 || slot?.isactive === true;
        const holiday =
          slot?.isholiday === 1 || slot?.isholiday === true;
        return active && !holiday;
      })
      .map((slot) =>
        new Date(slot?.startTime).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      )
      .sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      );
    setSlotDates_(activeDates);
  }, [CreateRequestDetailsStore?.slotsAvailable]);

  return (
    <div className="create-request-container">
      <CloseBtn
        color={"--dark"}
        closeHandler={() => {
          clearCreateRequestData_();
          setCreatemodal_(false);
          setAddresslist_([]);
          setBikelist_([]);
          _Post_MobileNumber.setData(null);
        }}
      />
      <UserCard
        title={"Create Request"}
        titleDescription={null}
        day={"Today"}
        date={formatDate(new Date())}
        color={"--dark"}
      />

      <div className="create-input_container">
        {/* MOBILE */}
        <div className="input-item-wrapper">
          <label htmlFor="mobile">
            <TitleExpand title={"mobile number"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <input
              type="text"
              placeholder="+91 -"
              name="mobile"
              id="mobile"
              onInput={TextInputHandler}
              value={RequestUserStore?.mobile}
            />
          </div>
        </div>
        {/* EMAIL ID */}
        <div className="input-item-wrapper">
          <label htmlFor="email">
            <TitleExpand title={"Email ID"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <input
              type="email"
              placeholder="test@example.com"
              name="email"
              id="email"
              onInput={TextInputHandler}
              value={RequestUserStore?.email}
            />
          </div>
        </div>

        {/* NAME */}
        <div className="input-item-wrapper">
          <label htmlFor="name">
            <TitleExpand title={"customer name"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <input
              type="text"
              placeholder="Name"
              name="name"
              id="name"
              onInput={TextInputHandler}
              value={RequestUserStore?.name}
            />
          </div>
        </div>

        {/* ADDRESS */}
        <div className="input-item-wrapper">
          <label htmlFor="address_type">
            <TitleExpand title={"customer address"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <input
              type="text"
              placeholder="pincode"
              name="pincode"
              id="pincode"
              onInput={TextInputHandler}
              value={RequestUserStore?.pincode}
              maxLength={6}
            />
          </div>
          <div className="input-item-field">
            <input
              type="text"
              placeholder="Address name"
              name="addressName"
              id="addressName"
              onInput={TextInputHandler}
              value={RequestUserStore?.addressName}
            />
          </div>
          <div className="input-item-field">
            <select
              name="address_type"
              id="address_type"
              value={RequestUserStore?.address_type}
              onChange={SelectHandler}
            >
              <option value="" disabled selected>
                Address type
              </option>
              {CreateRequestDetailsStore?.addressTypeList?.map(
                (item, index) => {
                  return (
                    <option key={item?._id} value={item?._id}>
                      {item?.bikeAddressTypeDescription}
                    </option>
                  );
                },
              )}
            </select>
          </div>

          <div className="input-item-field">
            <textarea
              type="text"
              placeholder="Full address"
              name="full_address"
              id="full_address"
              onInput={TextInputHandler}
              value={RequestUserStore?.full_address}
            />
          </div>
          <div className="input-item-field">
            <select
              name="state"
              id="state"
              value={RequestUserStore?.state || ""}
              onChange={StateHandler}
            >
              <option value="" disabled>
                State
              </option>
              {CreateRequestDetailsStore?.stateList?.map((item, index) => {
                return (
                  <option key={item?.stateCode} value={`${item?._id}`}>
                    {item?.stateName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="input-item-field">
            <select
              name="city"
              id="city"
              value={RequestUserStore?.city}
              onChange={SelectHandler}
            >
              <option value="" disabled>
                City
              </option>
              {CreateRequestDetailsStore?.cityList?.map((item, index) => {
                return (
                  <option key={item?.cityCode} value={item?._id}>
                    {item?.cityName}
                  </option>
                );
              })}
            </select>
          </div>

          {CreateRequestDetailsStore?.addresslist?.length > 0 && (
            <div className="choose-address-container">
              <p className="title">
                or <br />
                Choose address
              </p>
              <div className="request-addresslist-container">
                {CreateRequestDetailsStore?.addresslist?.map((item, index) => {
                  return (
                    <button
                      key={item?._id}
                      className={`choose-address-item ${RequestUserStore?.address_id == item?._id
                          ? "active"
                          : ""
                        }`}
                      onClick={() => {
                        AddressItemSet(item);
                      }}
                    >
                      <p className="type">{item?.addressName}</p>
                      <p className="type">{item?.addressType}</p>
                      <p className="address">
                        {item?.fullAddress} {item?.city},{item?.state} pincode-
                        {item?.pincode}
                      </p>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* FRAME NUMBER */}
        {/* <div className="input-item-wrapper">
          <label htmlFor="frame_number">
            <TitleExpand title={"Frame number"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <input
              type="text"
              placeholder="1X00Xx00"
              name="frame_number"
              id="frame_number"
              onInput={TextInputHandler}
              value={RequestUserStore?.frame_number}
            />
          </div>
        </div> */}

        {/* BRANCH */}
        <div className="input-item-wrapper">
          <label htmlFor="branch">
            <TitleExpand title={"Branch"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <select
              name="branch"
              id="branch"
              value={RequestUserStore?.branch}
              onChange={SelectHandler}
            >
              <option value="" disabled selected>
                Select branch
              </option>
              {CreateRequestDetailsStore?.branchList?.map((item, index) => {
                // //console.logitem)

                return (
                  <option key={item?._id} value={item?._id}>
                    {item?.branchName}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* SERVICE REQUIRED */}
        <div className="input-item-wrapper">
          <label htmlFor="serviceRequired">
            <TitleExpand title={"required service"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <select
              name="serviceRequired"
              id="serviceRequired"
              value={RequestUserStore?.serviceRequired}
              onChange={SelectHandler}
            >
              <option value="" disabled selected>
                Select service required
              </option>

              {CreateRequestDetailsStore?.serviceRequired
                // ?.filter(
                //   (item) =>
                //     !(
                //       RequestUserStore?.amcAvailable === 1 &&
                //       item.serviceTypeCode === "PUMB"
                //     ),
                // )
                ?.map((item, index) => {
                  return (
                    <option key={item?._id} value={item?._id}>
                      {item?.serviceTypeDescription}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        {/* SERVICE TYPE */}
        {/* <div className="input-item-wrapper">
          <label htmlFor="serviceType">
            <TitleExpand title={"Service location"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <select
              name="serviceType"
              id="serviceType"
              value={RequestUserStore?.serviceType}
              onChange={ServiceTypeHandler}
            >
              <option value="" disabled selected>
                Service location
              </option>
              {CreateRequestDetailsStore?.serviceType?.map((item, index) => {
                return (
                  <option
                    key={item?.serviceId}
                    value={`${index}==${item?.serviceId}`}
                  >
                    {item?.serviceTypename}
                  </option>
                );
              })}
            </select>
          </div>
        </div> */}

        {/* SERVICE PACKAGE */}
        <div className="input-item-wrapper">
          <label htmlFor="servicePackage">
            <TitleExpand title={"Service package"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <select
              name="servicePackage"
              id="servicePackage"
              value={RequestUserStore?.servicePackage}
              onChange={SelectHandler}
            >
              <option value="" disabled selected>
                Service package
              </option>
{CreateRequestDetailsStore?.servicePackage
                ?.filter(
                  (item, index, arr) =>
                    arr.findIndex(
                      (p) =>
                        (p?.serviceCategoryName || p?._id) ===
                        (item?.serviceCategoryName || item?._id)
                    ) === index
                )
                ?.map((item, index) => {
                  return (
                    <option
                      key={`${item?.serviceCategoryName || item?._id || index}_${index}`}
                      value={item?.serviceCategoryName}
                    >
                      {item?.serviceCategoryName}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        {/* <div className="create-location-service-container">
        <TitleExpand title={"Service location"} color={"--dark"} />

            <div className="create-location-service-btn">
                <button className="location-btn-item active">
                    In Home
                </button>
                <button className="location-btn-item">
                    In Store
                </button>
            </div>

        </div> */}

        {/* DATE & TIME */}
        {/* <div className="input-item-wrapper">
          <div className="create-date-time-container">
            <label htmlFor="date_time">
              <TitleExpand title={"Date & time"} color={"--dark"} />
            </label>
            <input
              type="datetime-local"
              name="date_time"
              id="date_time"
              onInput={TextInputHandler}
              value={RequestUserStore?.date_time}
            />
          </div>
        </div> */}
        {/* OFFER */}
        {/* <div className="input-item-wrapper">
          <label htmlFor="offer">
            <TitleExpand title={"add offer"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <select
              name="offer"
              id="offer"
              value={RequestUserStore?.offer}
              onChange={SelectHandler}
            >
              <option value="" disabled selected>
                Select offer
              </option>
              {CreateRequestDetailsStore?.offerList?.map((item, index) => {
                return (
                  <option key={item?._id} value={item?._id}>
                    {item?.label}
                  </option>
                );
              })}
            </select>
          </div>
        </div> */}

        {/* AMOUNT */}
        <div className="input-item-wrapper">
          <label htmlFor="amount">
            <TitleExpand title={"Amount "} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <input
              type="text"
              placeholder="Rs."
              name="amount"
              id="amount"
              // onInput={TextInputHandler}
              value={RequestUserStore?.amount}
              readOnly
            />
          </div>
        </div>

        {/**service Date */}
        <div className="input-item-wrapper">
          <label htmlFor="servicePackage">
            <TitleExpand title={"Booking Date"} color={"--dark"} />
          </label>
          <div className="input-item-field">
            <select
              name="slotDate"
              id="servicePackage"
              value={RequestUserStore?.slotDate}
              onChange={SelectHandler}
            >
              <option value="" disabled selected>
                Booking Date
              </option>
              {CreateRequestDetailsStore?.slotDates
                ?.map((item, index) => {
                  return (
                    <option key={item?.id || index} value={item}>
                      {item}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        {/**service Time Slot */}
        {CreateRequestDetailsStore?.slotTimeList?.length > 1 && (
          <div className="input-item-wrapper">
            <label htmlFor="slotTime">
              <TitleExpand title={"Slot Time"} color={"--dark"} />
            </label>
            <div className="input-item-field">
              <select
                name="slotTime"
                id="slotTime"
                value={RequestUserStore?.slotTime}
                onChange={SelectHandler}
              >
                <option value="" disabled selected>
                  Service Time
                </option>
                {CreateRequestDetailsStore?.slotTimeList
                  ?.filter((item) => item.status === 1)
                  .map((item, index) => {
                    return (
                      <option key={item?.id} value={item?.bookingDate || item?.startTime}>
                        {`${timeFormater(item.startTime)}-${timeFormater(item.endTime)}`}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateRequest;
